<template>
  <div class="rf-picker-icon rf-input-group" v-show='cpntMostrar'>
    <template v-if='cpntStatus !== ""'>
      <RF-Status :cpntStatus='cpntStatus' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <div>
        <RF-Button
          :data-time='time'

          :cpntStatus='""' 
          :cpntId='cpntId' 
          :cpntClass='cpntClassButton'
          :tabIndex='cpntTabIndex'
          :disabled='cpntDisabled'
          :key="icone.src"
          @onClickButton='pickerIconMostrarOcultarIcones'>
          <template slot="conteudo">
            <span :data-time='time' :title="icone.class">
              <!-- MOSTRA O ICONE SELECIONADO -->
              <i v-if="Object.keys(icone).length >= 1 && [ '', null, undefined ].indexOf(icone.src) === -1" class="icone-rf" :class="icone.src" />
              
              <!-- MOSTRA OS RISCOS QUANDO NÃO TEM ICONE -->
              <div style="width: 13px;" v-else>&nbsp;</div>
            </span>
          </template>
        </RF-Button>

        <label :for='cpntId' :class='"has-" + cpntMensagemTipo'>
          <span v-html='cpntNome'></span>

          <RF-Explica v-if='[ "", null, undefined ].indexOf(cpntExplica) === -1 && Object.keys(cpntExplica).length >= 1'
            :cpntId='cpntId + "-explica"' 
            :cpntTitle='cpntExplica.mensagem'
            :cpntPositionMy='cpntExplica.posicaoMy'
            :cpntPositionAt='cpntExplica.posicaoAt'
            :cpntClasses='cpntExplica.class'

            style='vertical-align: 0px;'
          ></RF-Explica>
        </label>
        <span v-if='cpntMensagem !== "" && cpntMensagem !== null' v-html='cpntMensagem' :class='"has-" + cpntMensagemTipo'></span>
      </div>

      <RF-Dialog v-if="mostrar === true"
        :cpntStatus='statusGeral'
        :cpntLargura='"840px"'

        :cpntOnFecharDialog='pickerIconMostrarOcultarIcones'>
        <template slot='titulo'>
          <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
          Selecione o icone
        </template>

        <template slot='conteudo'>
          <div>
            <template v-for="(icon, index) in vetorFinal">
              <div class="rf-picker-item-icon" :class="Object.keys(icone).length >= 1 && icon.class === icone.class ? 'selected' : ''" :key="'icon-' + index" @click="pickerIconSelecionar(icon)">
                <div :title="icon.class">
                  <svg :class="pickerIconChaves(icon, 'src')"></svg>
                  <div class="rf-picker-item-icon-info">
                    <span class="class" v-html="pickerIconChaves(icon, 'class')"></span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </RF-Dialog>
    </template>
  </div>
</template>

<style scoped>
  .rf-picker-icon {
    margin-top: -5px;
  }

  .rf-picker-item-icon {
    width: 100px;
    min-height: 65px;
    margin: 5px;
    border-radius: 5px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #e4e4e4;
    display: inline-block;
  }

  .rf-picker-item-icon.selected,
  .rf-picker-item-icon:hover {
    background: #009688;
  }

  .rf-picker-item-icon.selected .rf-picker-item-icon-info, 
  .rf-picker-item-icon:hover .rf-picker-item-icon-info {
    background: #fff;
  }
  .rf-picker-item-icon-info {
    height: 25px;
  }
  .rf-picker-item-container * {
    margin: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0;
    outline: none;
  }
  .rf-picker-item-icon > div > svg {
    margin: 0px auto;
  }
  .rf-picker-item-icon .rf-picker-item-icon-preview {
    font-size: 40px;
    padding: 3px;
    display: block;
    color: #495057;
  }
  .rf-picker-item-icon-info .class {
    font-size: 12px;
    line-height: 12px;
    color: #adb5bd;
    display: block;
    padding: 2px 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .rf-input-group {
    display: inline-block;
    vertical-align: top;
    text-align: left;
  }
  .rf-input-group {
    position: relative;
    margin-bottom: 30px;
  }
    .rf-picker-icon > div > label {
      position: absolute;
      left: 0px;
      top: -20px;
      color: var(--color-base-02);
      transition: 0.2s ease all;
      -moz-transition: 0.2s ease all;
      -webkit-transition: 0.2s ease all;
      cursor: pointer;

      margin: 0px;
      white-space: nowrap;
    }   
      /* ------------------ LOCAL E COR QUE FICA O TITULO DO CAMPO APÓS PREENCHIDO ------------------ */
      .rf-picker-icon > div > button:focus ~ label, .rf-picker-icon > div > button.rf-button-focus-true ~ label {
        top: -20px;
      }
      .rf-picker-icon > div > button:focus ~ label {
        color: #4285f4;
      }

      .rf-picker-icon > div > button > span > svg {
        font-size: 20px;
      }
</style>

<style>
</style>

<script>
  import icons from "./icons.json";

  export default {
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {  
        type: String,
        required: false,
        default: function () {
          return 'rf-picker-' + Math.floor(Math.random() * (9999 - 1000)) + 1000
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntValue: {  
        type: String,
        required: false,
        default: function () {
          return 'adn'
        }
      },
      cpntClassButton: {
        type: Array,
        required: false,
        default: function () {
          return [ 'btn', 'btn-default' ]
        }
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    mounted: function () {
      this.pickerIconIniciar()
    },
    methods: {
      pickerIconIniciar: function () {
        var self = this
        
        // CHAMA A FUNÇÃO PARA APLICAR O FILTRO
        self.pickerIconFiltar(function () {
          // VERIFICA O VALOR INICIAL
          if (self.cpntValue !== '') {
            if ((Object.keys(self.icone).length >= 1 && (self.cpntValue !== self.icone.class)) || Object.keys(self.icone).length === 0) {
              var icone = ''
              if ([ '', null, undefined ].indexOf(self.cpntValue) === -1) {
                // SEPARA AS CLASS RECEBIDAS
                icone = self.cpntValue.split(' ')

                // PEGA O NOME DO ICONE
                icone = icone.length === 2 ? icone[1].substring(3, icone[1].length) : ''
              }

              var item = icons.filter(item => item.class === icone)

              // SETA O ICONE ENCONTRADO
              self.icone = self.pickerIconChaves(item[0])

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            }
          }
        })
      },
      pickerIconGetStyle: function (icon) {
        if (icon.styles.indexOf('regular') !== -1) {
          return 'fa'
        } else if (icon.styles.indexOf('solid') !== -1) {
          return 'fas'
        } else if (icon.styles.indexOf('brands') !== -1) {
          return 'fab'
        }
        return 'fa'
      },
      pickerIconChaves: function (icon, chave = 'all') {
        // MONTA AS CLASSES
        icon = Object.assign(icon, { src: [ this.pickerIconGetStyle(icon), ('fa-' + icon.class ), 'rf-picker-item-icon-preview' ] })

        // RETORNA O VALOR SOLICITADO
        return chave === 'all' ? icon : icon[chave]
      },
      pickerIconFiltar: function (callback = null) {
        // VERIFICA SE TEM ALGUMA BUSCA PREENCHIDA
        this.vetorFinal = icons

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK RECEBIDA
        if (callback !== null) {
          callback()
        }
      },
      pickerIconMostrarOcultarIcones: function () {
        this.mostrar = !this.mostrar
      },
      pickerIconSelecionar: function (icon) {
        // SETA O ICONE SELECIONADO
        this.icone = icon

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // FECHA A TELA APÓS SELECIONAR O ICONE
        this.pickerIconMostrarOcultarIcones()
      },
    },
    watch: {
      icone: function () {
        if (this.cpntValue !== this.icone.class) {
          // PEGA AS CLASS SELECIONADAS E REMOVE A CLASS QUE NÃO SERÁ UTILIZADA
          var src = this.icone.src.filter(item => [ 'rf-picker-item-icon-preview' ].indexOf(item) === -1).join(' ')

          // CHAMA A FUNÇÃO PARA ATUALIZAR O COMPONENT PAI
          this.cpntOnChange(src, this.cpntId)
        }
      },
      cpntValue: function () {
        this.pickerIconIniciar()
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        value: undefined,
        icone: {},
        busca: '',
        ignoreIcon: [ ],
        vetorFinal: [],
        mostrar: false
      }
    },
  }
</script>
